import { render, staticRenderFns } from "./VFormTemplateListItem.vue?vue&type=template&id=7c5c0894&scoped=true&"
import script from "./VFormTemplateListItem.vue?vue&type=script&lang=js&"
export * from "./VFormTemplateListItem.vue?vue&type=script&lang=js&"
import style0 from "./VFormTemplateListItem.vue?vue&type=style&index=0&id=7c5c0894&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5c0894",
  null
  
)

export default component.exports